const CLOSE = '@@Tab/Close';
import {reducer as reducerBase} from 'reactis-datagrid';

export function reducer(state, action) {
	switch (action.type) {
		case CLOSE:
			return state.delete(action.id);

		default:
			return reducerBase(state, action);
	}
}


// WEBPACK FOOTER //
// ./src/redux/modules/datagridTab.js